var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "url(#paint0_linear_1236_25300)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5781 21.1719C54.3903 21.1719 55.8594 19.7028 55.8594 17.8906C55.8594 16.0784 54.3903 14.6094 52.5781 14.6094C50.7659 14.6094 49.2969 16.0784 49.2969 17.8906C49.2969 19.7028 50.7659 21.1719 52.5781 21.1719Z",
    fill: "#66BFE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 19.7656C19.1853 19.7656 20.2344 20.8147 20.2344 22.1094C20.2344 23.4041 19.1853 24.4531 17.8906 24.4531C16.5959 24.4531 15.5469 23.4041 15.5469 22.1094C15.5469 20.8147 16.5959 19.7656 17.8906 19.7656Z",
    fill: "#66BFE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 25.8594C53.2008 25.8594 53.5156 25.5446 53.5156 25.1562C53.5156 24.7679 53.2008 24.4531 52.8125 24.4531C52.4242 24.4531 52.1094 24.7679 52.1094 25.1562C52.1094 25.5446 52.4242 25.8594 52.8125 25.8594Z",
    fill: "#D5E8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 55.3906C53.2008 55.3906 53.5156 55.0758 53.5156 54.6875C53.5156 54.2992 53.2008 53.9844 52.8125 53.9844C52.4242 53.9844 52.1094 54.2992 52.1094 54.6875C52.1094 55.0758 52.4242 55.3906 52.8125 55.3906Z",
    fill: "#D5E8FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4375 16.0156C43.8258 16.0156 44.1406 15.7008 44.1406 15.3125C44.1406 14.9242 43.8258 14.6094 43.4375 14.6094C43.0492 14.6094 42.7344 14.9242 42.7344 15.3125C42.7344 15.7008 43.0492 16.0156 43.4375 16.0156Z",
    fill: "#D5E8FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1562 17.8906C25.5446 17.8906 25.8594 17.5758 25.8594 17.1875C25.8594 16.7992 25.5446 16.4844 25.1562 16.4844C24.7679 16.4844 24.4531 16.7992 24.4531 17.1875C24.4531 17.5758 24.7679 17.8906 25.1562 17.8906Z",
    fill: "#D5E8FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 53.9844C17.1071 53.9844 17.4219 53.6696 17.4219 53.2812C17.4219 52.8929 17.1071 52.5781 16.7188 52.5781C16.3304 52.5781 16.0156 52.8929 16.0156 53.2812C16.0156 53.6696 16.3304 53.9844 16.7188 53.9844Z",
    fill: "#D5E8FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 36.1719C15.2321 36.1719 15.5469 35.8571 15.5469 35.4688C15.5469 35.0804 15.2321 34.7656 14.8438 34.7656C14.4554 34.7656 14.1406 35.0804 14.1406 35.4688C14.1406 35.8571 14.4554 36.1719 14.8438 36.1719Z",
    fill: "#D5E8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_25300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 12,
    height: 4,
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1831 21.8832C45.5343 21.2331 44.6716 20.875 43.7536 20.875H42.2031V20.5625C42.2031 19.7009 41.5022 19 40.6406 19H29.3906C28.5291 19 27.8281 19.7009 27.8281 20.5625V20.875H26.2721C24.3808 20.875 22.8403 22.4154 22.8382 24.3087L22.8125 47.5587C22.8115 48.4776 23.1682 49.3417 23.8169 49.9918C24.4656 50.6419 25.3284 51 26.2464 51H43.7279C45.6193 51 47.1597 49.4596 47.1618 47.5663L47.1875 24.3163C47.1886 23.3974 46.8318 22.5333 46.1831 21.8832ZM29.7031 20.875H40.3281V22.75H29.7031V20.875ZM45.2888 47.5642C45.2878 48.4249 44.5876 49.125 43.7279 49.125H26.2464C25.8291 49.125 25.4369 48.9622 25.1421 48.6667C24.8472 48.3712 24.6851 47.9784 24.6855 47.5608L24.7112 24.3108C24.7121 23.4501 25.4123 22.75 26.2721 22.75H27.8281V23.0625C27.8281 23.9241 28.5291 24.625 29.3906 24.625H40.6406C41.5022 24.625 42.2031 23.9241 42.2031 23.0625V22.75H43.7536C44.1709 22.75 44.5631 22.9128 44.8579 23.2083C45.1528 23.5038 45.315 23.8966 45.3145 24.3142L45.2888 47.5642Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7656 28.6719C39.4259 28.6719 43.2031 32.4491 43.2031 37.1094C43.2031 41.7697 39.4259 45.5469 34.7656 45.5469C30.1053 45.5469 26.3281 41.7697 26.3281 37.1094C26.3281 32.4491 30.1053 28.6719 34.7656 28.6719Z",
    fill: "#3B6BAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 33,
    width: 2.82844,
    height: 9.89956,
    rx: 1.41422,
    transform: "rotate(45 37 33)",
    fill: "#FFDA2D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2578,
    y: 35,
    width: 2.82844,
    height: 9.89956,
    rx: 1.41422,
    transform: "rotate(-45 30.2578 35)",
    fill: "#FFDA2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_25300",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#0294F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0274BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_25300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyShare);
export default __webpack_public_path__ + "static/media/icon_empty_share.32b76c8c96aada5e3b03ed19bebccf52.svg";
export { ForwardRef as ReactComponent };